import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    components: { MigBoardLeftMenu:() => import('./YWK_MigBoardLeftMenu.vue') },
})
export default class YWK_MigBoardLeftMenu extends Vue {
    @Prop({type: Number }) selectedMenuId!:number
    @Prop({type: Object }) board!:ywkMigration.board
}
